import { FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { YES } from "../../constants";

export function PayThreshAmtCrossValidator(): ValidatorFn {

    return (formGroup: FormGroup): ValidationErrors | null => {
        let result: ValidationErrors = null;
        if (YES === formGroup.controls.payFlag.value && (!formGroup.controls.payThreshAmt.value || formGroup.controls.payThreshAmt.value.length === 0)) {
            result = {
                payThreshAmtCrossValidation: "fieldValidation.required"
            };
        }
        return result;
    };

}
